var React = require('react');

function FacebookSquareColor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".facebook-1{fill:#3b5998;}.facebook-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#fff;}")),React.createElement("title",{"key":1},"facebook-square-color"),React.createElement("path",{"className":"facebook-1","d":"M25.2,0H97.68a25.27,25.27,0,0,1,25.2,25.2V97.68a25.27,25.27,0,0,1-25.2,25.2H25.2A25.27,25.27,0,0,1,0,97.68V25.2A25.27,25.27,0,0,1,25.2,0Z","key":2}),React.createElement("path",{"className":"cls-2","d":"M69.27,35.31H82.34V19.63H69.27A18.32,18.32,0,0,0,51,37.92v7.84H40.54V61.44H51v41.81H66.67V61.44H79.73l2.61-15.68H66.67V37.92a2.64,2.64,0,0,1,2.6-2.61Z","key":3})]);
}

FacebookSquareColor.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 122.88 122.88"};

module.exports = FacebookSquareColor;

FacebookSquareColor.default = FacebookSquareColor;
